module.exports = __webpack_public_path__ + "media/iconfont/material-icons-sharp-6efac231.woff";